import React from 'react';

const LoadingBar = ({ progress }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-purple-700 to-blue-900 bg-opacity-95">
    <div className="flex flex-col items-center w-80 max-w-full">
      <span className="mb-6 text-white text-lg font-semibold">Loading events...</span>
      <div className="w-full h-3 bg-white bg-opacity-20 rounded-full overflow-hidden mb-2">
        <div
          className="h-full bg-white transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>
      <span className="text-white text-xs">{Math.round(progress)}%</span>
    </div>
  </div>
);

export default LoadingBar;
